import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import DEVICE_CONTEXT from "src/context/customer/device";
import { BadgeButton } from "src/components/base/badges/base";
import ReadOnlyACLs from "src/components/acl";

/**
 * The properties for {@link TagOutboundACLs}
 */
export type TagOutboundACLsProps = {};

/**
 * Outbound ACLs of a tag
 */
function TagOutboundACLs(props: TagOutboundACLsProps) {
    const ctx = React.useContext(DEVICE_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            {ctx.device.outbound_access_rules.tags.map((anchor) => (
                <div key={anchor.uuid} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/tags/$tagId/outbound-acls"}
                        params={{ tagId: anchor.uuid }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`tag:${anchor.name}`}
                    </BadgeButton>

                    <ReadOnlyACLs rules={anchor.access_rules} src={{ type: "Tag", value: anchor }} />
                </div>
            ))}

            {ctx.device.outbound_access_rules.groups.map((anchor) => (
                <div key={anchor.uuid} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        className={"self-start"}
                        color={"blue"}
                        href={"/c/groups/$groupId/outbound-acls"}
                        params={{ groupId: anchor.uuid }}
                    >
                        {`group:${anchor.name}`}
                    </BadgeButton>

                    <ReadOnlyACLs
                        rules={anchor.access_rules}
                        src={{ type: "Group", value: { ...anchor, external_id: "", internet: false } }}
                    />
                </div>
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_customer/c/devices/$deviceId/_device/outbound-acls")({
    component: TagOutboundACLs,
});
